module.exports = __webpack_public_path__ + "src/shared-components/icons/checkbox-unselected.53ebe7629b52e3154e8523db12f6d379.svg";